import axios from '../utils/AxiosInstance'

export default {
  // namespaced: true,
  state: {
    shareCandidates: {
      selectIds: [],
      filters: {},
      paginate: {},
      selectId: false
    }
  },
  mutations: {
    SET_SHAREPLACEMENT_SELECT_IDS (store, ids) {
      store.shareCandidates.selectIds = ids
    },
    REMOVE_SHAREPLACEMENT_SELECT_IDS (store, ids) {
      store.shareCandidates.selectIds = store.shareCandidates.selectIds.filter((v) => { return !ids.includes(v) })
    },
    SET_SHAREPLACEMENT_SELECT_ID (store, id) {
      store.shareCandidates.selectId = id
    },
    SET_SHAREPLACEMENT_FILTERS (store, filters) {
      store.shareCandidates.filters = filters
    },
    SET_SHAREPLACEMENT_PAGINATE (store, val) {
      store.shareCandidates.paginate = {
        limit: val.limit,
        page: val.page,
        pages: val.pages,
        total: val.total
      }
    }
  },
  getters: {
    getShareCandidates: (store, getters) => {
      return store.shareCandidates.selectIds.map((id) => {
        return getters['entities/shareCandidates/find'](id)
      })
    },
    getShareCandidatesFilters: (store, getters) => {
      return store.shareCandidates.filters
    },
    getShareCandidatesPaginate: (store, getters) => {
      return store.shareCandidates.paginate
    },
    getShareCandidate: (store, getters) => {
      return getters['entities/shareCandidates/find'](store.shareCandidates.selectId) || {}
    }
  },
  actions: {
    /*
    selectShareCandidates
    */
    selectShareCandidates ({commit, dispatch, getters, state}, filters) {
      return dispatch('getShareCandidates', filters)
      .then((response) => {
        commit('SET_SHAREPLACEMENT_FILTERS', filters)
        commit('SET_SHAREPLACEMENT_PAGINATE', response)
        commit('SET_SHAREPLACEMENT_SELECT_IDS', response.docs.map((item) => { return item._id }))
        return response
      })
    },
    /*
    refreshSelectShareCandidates
    */
    refreshSelectShareCandidates ({commit, dispatch, getters, state}) {
      return dispatch('selectShareCandidates', getters.getShareCandidatesFilters)
    },
    /*
    selectShareCandidate
    */
    selectShareCandidate ({commit, dispatch, getters, state}, id) {
      return dispatch('getShareCandidateById', id)
      .then((response) => {
        commit('SET_SHAREPLACEMENT_SELECT_ID', response._id)
        return response
      })
    },
    /*
    getShareCandidates
    */
    getShareCandidates ({commit, dispatch, getters, state}, filters) {
      return axios
      .get(`/accounts/${getters.getAccount._id}/share-candidates`, {params: filters})
      .then((response) => {
        return dispatch('entities/shareCandidates/insert', {
          data: response.data.docs
        })
        .then((result) => {
          return {
            docs: result.shareCandidates || [],
            limit: response.data.limit,
            page: response.data.page,
            pages: response.data.pages,
            total: response.data.total
          }
        })
      })
    },
    /*
    getShareCandidateById
    */
    getShareCandidateById ({commit, dispatch, getters, state}, id) {
      return axios
      .get(`/accounts/${getters.getAccount._id}/share-candidates/${id}`)
      .then((response) => {
        return dispatch('entities/shareCandidates/insert', {
          data: response.data
        })
      })
      .then((result) => {
        return result.shareCandidates[0]
      })
    },
    /*
    createShareCandidate
    */
    createShareCandidate ({commit, dispatch, getters, state}, data) {
      delete data.$id

      return axios
      .post(`/accounts/${getters.getAccount._id}/share-candidates`, data)
      .then((response) => {
        return dispatch('entities/shareCandidates/insert', {
          data: response.data
        })
      })
      .then((response) => {
        return response.shareCandidates[0]
      })
    },
    /*
    updateShareCandidate
    */
    updateShareCandidate ({commit, dispatch, getters, state}, data) {
      delete data.$id

      return axios
      .put(`/accounts/${getters.getAccount._id}/share-candidates/${data._id}`, data)
      .then((response) => {
        return dispatch('entities/shareCandidates/insert', {
          data: response.data
        })
      })
      .then((response) => {
        return response.shareCandidates[0]
      })
    },
    /*
    deleteShareCandidate
    */
    deleteShareCandidate ({commit, dispatch, getters, state}, id) {
      return axios
      .delete(`/accounts/${getters.getAccount._id}/share-candidates/${id}`)
      .then((response) => {
        commit('REMOVE_SHAREPLACEMENT_SELECT_IDS', [id])
        dispatch('entities/shareCandidates/delete', id)
        return {}
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/ShareCandidate.js